export const pathList = {

    "s1": [
        {
            label: '/home/etc/',
            value: '/home/etc/'
        },
        {
            label: '/home/NetWorkScripts/',
            value: '/home/NetWorkScripts/'
        },
        {
            label: '/home/Program/',
            value: '/home/Program/'
        },
        {
            label: '/home/Program/WebService/',
            value: '/home/Program/WebService/'
        },
        {
            label: '/home/Program/IoT/',
            value: '/home/Program/IoT/'
        },
        {
            label: '/home/Program/extranet/',
            value: '/home/Program/extranet/'
        },
        {
            label: '/home/Program/FTPService/',
            value: '/home/Program/FTPService/'
        },
        {
            label: '/usr/local/samba/sbin/',
            value: '/usr/local/samba/sbin/'
        }
    ],
    "s2": [
        {
            label: '/home/Program/',
            value: '/home/Program/'
        },
        {
            label: '/home/Program/IoT/',
            value: '/home/Program/IoT/'
        },
        {
            label: '/home/Program/extranet/',
            value: '/home/Program/extranet/'
        },
        {
            label: '/home/Scripts/',
            value: '/home/Scripts/'
        },
        {
            label: '/home/Program/FTPService/',
            value: '/home/Program/FTPService/'
        },
        {
            label: '/usr/local/samba/sbin/',
            value: '/usr/local/samba/sbin/'
        }
    ],
    "h2": [
        {
            label: '/etc/init.d',
            value: '/etc/init.d'
        },
        {
            label: '/home/NetWorkScripts/',
            value: '/home/NetWorkScripts/'
        },
        {
            label: '/home/Program/',
            value: '/home/Program/'
        },
        {
            label: '/opt/',
            value: '/opt/'
        },
        {
            label: '/opt/FTPService/',
            value: '/opt/FTPService/'
        },
        {
            label: '/usr/qml/',
            value: '/usr/qml/'
        },
        {
            label: '/userdata/',
            value: '/userdata/'
        },
        {
            label: '/userdata/IoT/',
            value: '/userdata/IoT/'
        },
        {
            label: '/usr/local/samba/sbin/',
            value: '/usr/local/samba/sbin/'
        }
    ],
    "mtpad_linux": [
        {
            label: '/opt/',
            value: '/opt/'
        },
        {
            label: '/opt/IoT/',
            value: '/opt/IoT/'
        },
        {
            label: '/usr/bin/',
            value: '/usr/bin/'
        },
        {
            label: '/opt/ftp/',
            value: '/opt/ftp/'
        }
    ],
    "mtpad_android": [
        {
            label: '/etc/init.d/',
            value: '/etc/init.d/'
        },
        {
            label: '/etc/rc.local',
            value: '/etc/rc.local'
        },
        {
            label: '/home/android/',
            value: '/home/android/'
        },
        {
            label: '/home/android/extranet/',
            value: '/home/android/extranet/'
        },{
            label: '/home/android/ftp/',
            value: '/home/android/ftp/'
        },
        {
            label: '/home/android/IoT/',
            value: '/home/android/IoT/'
        }
    ],
    "default":[
        {
            label: '/etc/init.d',
            value: '/etc/init.d'
        },
        {
            label: '/etc/rc.local',
            value: '/etc/rc.local'
        },
        {
            label:'/home/android/',
            value:'/home/android/'
        },
        {
            label:'/home/android/extranet/',
            value:'/home/android/extranet/'
        },
        {
            label: '/home/android/ftp/',
            value: '/home/android/ftp/'
        },
        {
            label:'/home/android/IoT/',
            value:'/home/android/IoT/'
        },
        {
            label:'/home/etc/',
            value:'/home/etc/'
        },
        {
            label:'/home/NetWorkScripts/',
            value:'/home/NetWorkScripts/'
        },
        {
            label:'/home/Program/',
            value:'/home/Program/'
        },
        {
            label:'/home/Program/WebService/',
            value:'/home/Program/WebService/'
        },
        {
            label:'/home/Program/IoT/',
            value:'/home/Program/IoT/'
        },
        {
            label:'/home/Program/extranet/',
            value:'/home/Program/extranet/'
        },
        {
            label: '/home/Program/FTPService/',
            value: '/home/Program/FTPService/'
        },
        {
            label:'/home/Scripts/',
            value:'/home/Scripts/'
        },
        {
            label:'/opt/',
            value:'/opt/'
        },
        {
            label:'/opt/extranet/',
            value:'/opt/extranet/'
        },
        {
            label: '/opt/ftp/',
            value: '/opt/ftp/'
        },
        {
            label:'/opt/IoT/',
            value:'/opt/IoT/'
        },
        {
            label:'/usr/bin/',
            value:'/usr/bin/'
        },
        {
            label:'/userdata/extranet/',
            value:'/userdata/extranet/'
        },
        {
            label:'/userdata/IoT/',
            value:'/userdata/IoT/'
        },
        {
            label: '/usr/qml/',
            value: '/usr/qml/'
        },
        {
            label: '/usr/local/samba/sbin/',
            value: '/usr/local/samba/sbin/'
        }
    ]

}
